import { useMemo } from 'react';

import { Configuration, RiskServiceApi } from '@rtkwlf/mr-infra-risk';

import { useAuthContext } from '@packages/legacy/auth';
import { useOrganizationContext } from '@packages/legacy/organization-context';
import { useFeatureFlag } from '@packages/platform/feature-flags/use-feature-flag';
import { env } from '@packages/utils/env';

export const useRiskServiceApi = () => {
  const { fetchApi } = useAuthContext();
  const { selectedOrganization } = useOrganizationContext();
  const [testDataFF] = useFeatureFlag('RISK_IN_UP_LIVE_TEST_DATA');

  const riskServiceURL = env.VITE_MR_INFRA_RISK_BASE_PATH
    ? env.VITE_MR_INFRA_RISK_BASE_PATH
    : testDataFF
      ? 'https://risk.mr-infra-risk.us001-test.rtkwlf.io'
      : `https://risk.managedgw.${selectedOrganization.pod}-prod.arcticwolf.net`;

  const api = useMemo(
    () =>
      new RiskServiceApi(
        new Configuration({
          basePath: riskServiceURL,
          fetchApi,
        }),
      ),
    [fetchApi, riskServiceURL],
  );

  return api;
};
